<template>
  <div v-if="detail != null">
    <datalist id="towns">
      <option v-for="town in towns.keys()"> {{ town }}</option>
    </datalist>
    <datalist id="non-dismissed-towns">
      <option v-for="town in nonDismissedTowns.keys()"> {{ town }}</option>
    </datalist>
    <datalist id="nations">
      <option v-for="nation in nations.keys()"> {{ nation }}</option>
    </datalist>
    <datalist id="provinces">
      <option v-for="province in provinces"> {{ province }}</option>
    </datalist>
    <datalist id="non-dismissed-provinces">
      <option v-for="province in nonDismissedProvinces"> {{ province }}</option>
    </datalist>
    <b-form>
      <b-form-row>
        <b-form-group label="Codice Punto Vendita" class="col-md-4">
          <b-form-input :value="detail.storeCode" disabled/>
        </b-form-group>
        <b-form-group label="Tipo di Domanda" class="col-md-4">
          <b-form-input :value="demandType(detail.demandType)" disabled/>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Cognome" class="col-md-6">
          <b-input-group>
            <b-form-input disabled :value="detail.lastName" v-validate='{ required: true}' name="Cognome" :state="stateValidation('Cognome')"/>
            <b-input-group-append>
              <b-button id="edit-lastname-button" variant="success" @click="editField('lastName')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-lastName">{{ veeErrors.first('Cognome') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Nome" class="col-md-6">
          <b-input-group>
            <b-form-input disabled :value="detail.firstName" v-validate='{ required: true}' name="Nome" :state="stateValidation('Nome')"/>
            <b-input-group-append>
              <b-button id="edit-firstname-button" variant="success" @click="editField('firstName')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-firstName">{{ veeErrors.first('Nome') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Sesso" class="col-md-4">
          <b-input-group>
            <b-form-input disabled :value="detail.sex" v-validate='{ required: true}' name="Sesso" :state="stateValidation('Sesso')"/>
            <b-input-group-append>
              <b-button id="edit-sex-button" variant="success" @click="editField('sex')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-sex">{{ veeErrors.first('Sesso') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Codice Fiscale" class="col-md-8">
          <b-input-group>
            <b-form-input :value="detail.fiscalCode" disabled/>
            <b-input-group-append>
              <b-button id="edit-fiscalcode-button" variant="success" @click="editField('fiscalCode')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Data di Nascita" class="col-md-4">
          <b-input-group>
            <b-form-datepicker
              v-model="detail.birthDate"
              :date-format-options="dateFormat"
              disabled locale="it-IT"
              v-validate='{ required: true}'
              name="Data di Nascita"
              :state="stateValidation('Data di Nascita')"/>
            <b-input-group-append>
              <b-button id="edit-birth-date-button" variant="success" @click="editField('birthDate')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-birthDate">{{ veeErrors.first('Data di Nascita') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Luogo di Nascita" class="col-md-6">
          <b-input-group>
            <b-form-input disabled :value="detail.birthPlaceCity" v-validate='{ required: true}' name="Luogo di nascita" :state="stateValidation('Luogo di nascita')"/>
            <b-input-group-append>
              <b-button id="edit-birth-place-city-button" variant="success" @click="editField('birthPlaceCity')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-birthPlaceCity">{{ veeErrors.first('Luogo di Nascita') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Provincia di Nascita" class="col-md-2"
                      v-if="isItalianBirthPlace(detail.birthPlaceProvince)">
          <b-input-group>
            <b-form-input disabled :value="detail.birthPlaceProvince" v-validate='{ required: true}' name="Provincia di nascita" :state="stateValidation('Provincia di nascita')"/>
            <b-input-group-append>
              <b-button id="edit-birth-place-province-button" variant="success" @click="editField('birthPlaceProvince')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-birthPlaceProvince">{{ veeErrors.first('Provincia di Nascita') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Via" class="col-md-8">
          <b-input-group>
            <b-form-input disabled :value="detail.street" v-validate='{ required: true}' name="Via" :state="stateValidation('Via')"/>
            <b-input-group-append>
              <b-button id="edit-street-button" variant="success" @click="editField('street')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-street">{{ veeErrors.first('Via') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Numero Civico" class="col-md-4">
          <b-input-group>
            <b-form-input disabled :value="detail.civicNumber" v-validate='{ required: true}' name="Numero Civico" :state="stateValidation('Numero Civico')"/>
            <b-input-group-append>
              <b-button id="edit-civic-number-button" variant="success" @click="editField('civicNumber')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-civicNumber">{{ veeErrors.first('Numero Civico') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="CAP" class="col-md-3">
          <b-input-group>
            <b-form-input disabled :value="detail.postalCode" v-validate='{ required: true}' name="CAP" :state="stateValidation('CAP')"/>
            <b-input-group-append>
              <b-button id="edit-postal-code-button" variant="success" @click="editField('postalCode')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-postalCode">{{ veeErrors.first('CAP') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Città" class="col-md-4">
          <b-input-group>
            <b-form-input disabled :value="detail.town" v-validate='{ required: true}' name="Città" :state="stateValidation('Città')"/>
            <b-input-group-append>
              <b-button id="edit-town-button" variant="success" @click="editField('town')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-town">{{ veeErrors.first('Città') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Provincia di Residenza" class="col-md-2">
          <b-input-group>
            <b-form-input disabled :value="detail.province" v-validate='{ required: true}' name="Provincia di Residenza" :state="stateValidation('Provincia di Residenza')"/>
            <b-form-invalid-feedback id="input-province">{{ veeErrors.first('Provincia di Residenza') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Nazione di Residenza" class="col-md-3">
          <b-input-group>
            <b-form-input disabled :value="detail.nation" v-validate='{ required: true}' name="Nazione" :state="stateValidation('Nazione')"/>
            <b-input-group-append>
              <b-button id="edit-nation-button" variant="success" @click="editField('nation')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-nation">{{ veeErrors.first('Nazione') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>

        <b-form-group label="Prefisso" class="col-md-2">
          <b-input-group>
            <b-form-input disabled :value="detail.mobilePhonePrefix" v-validate='{ required: true}' name="Prefisso" :state="stateValidation('Prefisso')"/>
            <b-input-group-append>
              <b-button id="edit-mobile-phone-prefix-button" variant="success" @click="editField('mobilePhonePrefix')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-mobile-phone-prefix">{{ veeErrors.first('Prefisso') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>


        <b-form-group label="Cellulare" class="col-md-4">
          <b-input-group>
            <b-form-input disabled :value="detail.mobilePhone" v-validate="validationRulesFor('mobilePhone')" name="Cellulare" :state="stateValidation('Cellulare')"/>
            <b-input-group-append>
              <b-button id="edit-mobile-phone-button" variant="success" @click="editField('mobilePhone')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-feedback">{{ veeErrors.first('Cellulare') }}</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Telefono Fisso" class="col-md-6">
          <b-input-group>
            <b-form-input :value="detail.telephone" disabled/>
            <b-input-group-append>
              <b-button id="edit-telephone-button" variant="success" @click="editField('telephone')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Email" class="col-md-12">
          <b-input-group>
            <b-form-input :value="detail.email" disabled/>
            <b-input-group-append>
              <b-button id="edit-email-button" variant="success" @click="editField('email')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Consensi" class="col-md-12">
          <b-form-checkbox-group v-model="consensus" size="lg">
            <b-form-checkbox value="marketing" disabled>Marketing</b-form-checkbox>
            <b-form-checkbox value="profiling" disabled>Profilazione</b-form-checkbox>
            <b-form-checkbox value="cooperatives" disabled>Cooperativi</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-form-row>
      <b-form-row>
        <b-form-group label="Data di Nascita Primo Figlio" class="col-md-4">
          <b-input-group>
            <b-form-datepicker v-model="detail.child1BirthDate" :date-format-options="dateFormat" disabled
                               locale="it-IT"/>
            <b-input-group-append>
              <b-button id="edit-child1-birth-date-button" variant="success" @click="editField('child1BirthDate')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Data di Nascita Secondo Figlio" class="col-md-4">
          <b-input-group>
            <b-form-datepicker v-model="detail.child2BirthDate" :date-format-options="dateFormat" disabled
                               locale="it-IT"/>
            <b-input-group-append>
              <b-button id="edit-child2-birth-date-button" variant="success" @click="editField('child2BirthDate')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Data di Nascita Terzo Figlio" class="col-md-4">
          <b-input-group>
            <b-form-datepicker v-model="detail.child3BirthDate" :date-format-options="dateFormat" disabled
                               locale="it-IT"/>
            <b-input-group-append>
              <b-button id="edit-child3-birth-date-button" variant="success" @click="editField('child3BirthDate')">
                <b-icon-pencil-fill></b-icon-pencil-fill>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </b-form-row>
    </b-form>
    <b-modal id="edit-modal" title="Modifica il valore" @ok="save" ok-title="Salva" cancel-title="Annulla" hide-header-close no-close-on-backdrop>
        <b-form-group>
          <b-form-input
            autocomplete="off"
            id="input-edit"
            v-on:blur="validateBirthPlaceCity()"
            :list="getAutocompleteList()"
            v-model="modified.value"
            v-if="isText"
            :name="modified.name"
            v-validate="validationRulesFor(modified.field)"
            :state="stateValidation(modified.name)"
            aria-describedby="input-feedback"
            @input="toUpperCase"
          />

          <DatePicker
            :id="modified.field"
            v-model="modified.value"
            :description="modified.field"
            :required="validationRulesFor(modified.field)"
            v-if="isDate"
          />

          <b-form-radio-group
            id="radio-edit"
            v-model="modified.value"
            :options="modified.genderOptions"
            v-if="isRadioGender"
          />

          <b-form-radio-group
            id="radio-edit"
            v-model="modified.value"
            :options="modified.mobilePhonePrefixOptions"
            v-if="isRadioMobilePhonePrefix"
          />

          <b-form-invalid-feedback id="input-feedback">{{ veeErrors.first(modified.name) }}</b-form-invalid-feedback>
        </b-form-group>
      <div class="text-center" v-show="saving">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PaperAgreementsApi from '@/api/PaperAgreementsApi'
import demandsType from "@/DemandsType";
import NationsApi from '@/api/NationsApi'
import TownsApi from '@/api/TownsApi'
import {isValidPhoneNumber} from "libphonenumber-js";
import DatePicker from "@/components/DatePicker";
import genders from "@/Genders";
import phonePrefixes from "@/assets/phone-prefix.json";

export default {
  name: 'PaperAgreementDetail',
  components: {DatePicker},
  props: ['paperAgreementId'],
  inject: ['parentValidator'],
  created() {
    this.$validator = this.parentValidator
  },
  data() {
    return {
      saving: false,
      detail: null,
      consensus: [],
      modified: {
        name: null,
        field: null,
        value: null,
        type: 'text',
        genderOptions: genders,
        mobilePhonePrefixOptions: phonePrefixes
        .filter(prefix => prefix.code === 'IT' || prefix.code === 'CH' || prefix.code === 'DE')
          .map(prefix => ({text: `${prefix.name} (${prefix.code}) ${prefix.prefix}`, value: prefix.prefix}))
          .sort((firstPrefix, secondPrefix) => ('' + firstPrefix.name).localeCompare(secondPrefix.name))
      },
      dateFormat: {'day': 'numeric', 'month': 'numeric', 'year': 'numeric'},
      disabled: {
        firstName: true,
        lastName: true,
        sex: true,
        birthDate: true,
        birthPlaceCity: true,
        birthPlaceProvince: true,
        street: true,
        fiscalCode: true,
        civicNumber: true,
        postalCode: true,
        town: true,
        province: true
      },
      towns: new Map(),
      nonDismissedTowns: new Map(),
      nations: new Map(),
      provinces: new Set(),
      nonDismissedProvinces: new Set()
    }
  },
  computed: {
    isText() {
      return this.modified.type === 'text'
    },
    isDate() {
      return this.modified.type === 'date'
    },
    isRadioGender() {
      return this.modified.type === 'radioGender'
    },
    isRadioMobilePhonePrefix() {
      return this.modified.type === 'radioMobilePhonePrefix'
    }
  },
  mounted() {
    this.paperAgreement()
    this.initTownsAndNations()

    this.$validator.extend('mobilePhoneValidator', {
      getMessage: field => `Il numero di ${field} non è valido`,
      validate: value => {
        const prefix = phonePrefixes.find(prefix => prefix.prefix === this.detail.mobilePhonePrefix).code;
        return  isValidPhoneNumber(value, prefix)
      }
    })
  },
  methods: {
    validateBirthPlaceCity() {
      if (this.modified.field === 'birthPlaceCity') {
        if (this.isItalianBirthPlace(this.detail.birthPlaceProvince)) {
          this.modified.value = this.towns.get(this.modified.value) ? this.modified.value : ''
        } else {
          this.modified.value = this.nations.get(this.modified.value) ? this.modified.value : ''
        }
      }

    },
    isItalianBirthPlace(provinceCode) {
      return Array.from(this.provinces).filter(item => item === provinceCode).length !== 0
    },
    isItalianTown(town) {
      return Array.from(this.nonDismissedTowns).filter(item => item[0] === town).length !== 0
    },
    getAutocompleteList() {
      switch (this.modified.field) {
        case 'birthPlaceCity':
          return this.isItalianBirthPlace(this.detail.birthPlaceProvince) ? 'towns' : 'nations'
        case 'town':
          return 'non-dismissed-towns'
        case 'birthPlaceProvince':
          return 'provinces'
        case 'nation':
          return 'nations'
        default: return ''
      }
    },
    initTownsAndNations() {
      TownsApi.all().then((result) => {
        this.towns = new Map(result.map((town) => [town.name, town.provinceCode]))
        this.provinces = new Set(result.map(town => town.provinceCode))
      })

      TownsApi.nonDismissed().then((result) => {
        this.nonDismissedTowns = new Map(result.map((town) => [town.name.toUpperCase(), town.provinceCode]))
        this.nonDismissedProvinces = new Set(result.map(town => town.provinceCode))
      })

      NationsApi.all().then((result) => {
        this.nations = new Map(result.map((nation) => [nation.name, nation.codeIsoAlpha3]))
        this.nations.set("Italia", "ITA")
      })
    },
    editField(field) {
      this.modified.field = field
      this.modified.name = this.nameFrom(field)
      this.modified.value = this.detail[field]

      switch (field) {
        case 'birthDate':
        case 'child1BirthDate':
        case 'child2BirthDate':
        case 'child3BirthDate':
          this.modified.type = 'date'
          break
        case 'sex':
          this.modified.type = 'radioGender'
          break
        case 'mobilePhonePrefix':
          this.modified.type = 'radioMobilePhonePrefix'
          break
        default:
          this.modified.type = 'text'
          break
      }

      this.$bvModal.show('edit-modal')
    },
    nameFrom(field) {
      switch (field) {
        case 'firstName':
          return 'Nome'
        case 'lastName':
          return 'Cognome'
        case 'sex':
          return 'Sesso'
        case 'birthDate':
          return 'Data di nascita'
        case 'birthPlaceCity':
          return 'Luogo di nascita'
        case 'birthPlaceProvince':
          return 'Provincia di nascita'
        case 'street':
          return 'Via'
        case 'fiscalCode':
          return 'Codice Fiscale'
        case 'civicNumber':
          return 'Numero civico'
        case 'postalCode':
          return 'CAP'
        case 'town':
          return 'Città'
        case 'province':
          return 'Provincia di Residenza'
        case 'nation':
          return 'Nazione di Residenza'
        case 'mobilePhone':
          return 'Cellulare'
        case 'mobilePhonePrefix':
          return 'Prefisso cellulare'
        case 'telephone':
          return 'Telefono fisso'
        case 'email':
          return 'Email'
        case 'child1BirthDate':
          return 'Data di nascita primo figlio'
        case 'child2BirthDate':
          return 'Data di nascita secondo figlio'
        case 'child3BirthDate':
          return 'Data di nascita terzo genito'
      }
    },
    demandType(demandType) {
      return demandsType.find(type => type.value === demandType).text
    },
    paperAgreement() {
      PaperAgreementsApi.getAgreement(this.paperAgreementId)
        .then(paperAgreement => {
          this.detail = paperAgreement
          if(this.detail.mobilePhone.includes("+")){
            this.detail.mobilePhone = this.detail.mobilePhone.split(" ")[1]
          }
          if (this.detail.marketingConsensus) this.consensus.push('marketing')
          if (this.detail.profilingConsensus) this.consensus.push('profiling')
          if (this.detail.cooperativesConsensus) this.consensus.push('cooperatives')
          this.detail.mobilePhonePrefix = paperAgreement.mobilePhonePrefix || '+39'
        })
    },
    dont(event) {
      event.preventDefault()
    },
    save(modalEvent) {
      //modalEvent.preventDefault()

      if (!this.isDate) {
        this.$validator.attach({
          name: this.modified.field,
          rules: this.validationRulesFor(this.modified.field),
          getter: () => this.modified.value
        })
      }

      this.$validator.validate(this.modified.field).then(result => {
        if (result) {
          this.saving = true
          let detail = {}

          if (this.modified.field === 'birthPlaceCity' && !this.isItalianBirthPlace(this.detail.birthPlaceProvince)) {
            let newBirthPlaceProvince = this.nations.get(this.modified.value);
            detail.birthPlaceProvince = newBirthPlaceProvince
            this.detail.birthPlaceProvince = newBirthPlaceProvince
          } else if (this.modified.field === 'birthPlaceCity' && this.isItalianBirthPlace(this.detail.birthPlaceProvince)) {
            let newBirthPlaceProvince = this.towns.get(this.modified.value);
            detail.birthPlaceProvince = newBirthPlaceProvince
            this.detail.birthPlaceProvince = newBirthPlaceProvince
          } else if (this.modified.field === 'town' && this.isItalianTown(this.modified.value)) {
            let newResidenceProvince = this.nonDismissedTowns.get(this.modified.value)
            detail.province = newResidenceProvince
            this.detail.province = newResidenceProvince
          }

          detail[this.modified.field] = this.modified.value
          PaperAgreementsApi.update(this.paperAgreementId, detail)
            .then(() => {
              this.detail[this.modified.field] = this.modified.value
              this.$bvModal.hide('edit-modal')
            })
            .finally(() => {
              this.saving = false
              this.$bvModal.hide('edit-modal')
            })
        }
      })

      if (!this.isDate) this.$validator.detach(this.modified.field)
    },
    validationRulesFor(field) {
      const provinceValidation = Array.from(this.provinces).join('|')
      const townValidation = Array.from(this.towns.keys()).join('|')
      const nationValidation = Array.from(this.nations.keys()).join('|')

      switch (field) {
        case 'firstName':
          return {required: true}
        case 'lastName':
          return {required: true}
        case 'sex':
          return {required: true}
        case 'mobilePhonePrefix':
          return {required: true}
        case 'birthDate':
          return true
        case 'birthPlaceCity':
          return {required: true}
        case 'birthPlaceProvince':
          return {required: true, regex: provinceValidation}
        case 'street':
          return {required: true}
        case 'fiscalCode':
          return {required: false, regex: /^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i}
        case 'civicNumber':
          return {required: true}
        case 'postalCode':
          return {required: true, min: 5, max: 5}
        case 'town':
          return {required: true, regex: townValidation}
        case 'province':
          return {required: true, regex: provinceValidation}
        case 'nation':
          return {required: true, regex: nationValidation}
        case 'mobilePhone':
          return {numeric: true, min: 5, mobilePhoneValidator: true}
        case 'telephone':
          return {required: false, numeric: true}
        case 'email':
          return {required: false, email: true}
        case 'child1BirthDate':
          return false
        case 'child2BirthDate':
          return false
        case 'child3BirthDate':
          return false
      }
    },
    stateValidation(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      } else {
        return null
      }
    },
    toUpperCase(value) {
      if (this.modified.field === 'fiscalCode')
        this.modified.value = value.toUpperCase()
    }
  }
}
</script>

<style scoped>

</style>
